import { useState } from 'react';
import { Buttons, FlexContainer, Separator, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { useTranslation } from 'Hooks/useTranslation';
import { AuthContainer, GradientBg } from 'Components/UI';
import AppHeader from 'Components/AppHeader';
import SocialButton from 'Components/UI/SocialButton';
import CustomTransition from 'Components/CustomTransition';
import EmailButton from 'Components/UI/EmailButton';
import { routes } from 'Constants/routes';
import { SocialProviders } from 'Types/common';
import { SignInForm } from './components';
import { SignInViewProps } from './types';

const SignInView = ({ onSignInSocial, errorSocialLogin }: SignInViewProps): JSX.Element => {
  const [showForm, setShowForm] = useState(false);
  const { t } = useTranslation(locizeNS.AUTH);
  return (
    <>
      <AppHeader />
      <GradientBg>
        <AuthContainer>
          <FlexContainer direction="column" gap="dimension_16">
            <Text type="headline" color="dark" size="S_L_S" align="center">
              {t('Auth.signIn.title')}
            </Text>
            <Text type="paragraphs" color="dark" size="M_L_S" align="center">
              {t('Auth.signIn.formTiltle')}
            </Text>
            <FlexContainer direction="column" gap="dimension_24">
              {(showForm || errorSocialLogin) && (
                <>
                  <CustomTransition start>
                    <SignInForm />
                  </CustomTransition>
                  <Separator content="o" />
                </>
              )}
              {Object.values(SocialProviders).map(provider => (
                <SocialButton
                  key={provider}
                  onClick={() => onSignInSocial(provider)}
                  type={provider}
                  label={t(`SignIn.${provider}`)}
                />
              ))}
              {!showForm && !errorSocialLogin && <EmailButton onClick={() => setShowForm(true)} />}
            </FlexContainer>
            <FlexContainer justify="center" gap="dimension_08" align="center">
              <Text type="paragraphs" size="M_S_S" color="dark">
                {t('Auth.signIn.notAccount')}
              </Text>
              <Buttons.Tiny
                label={t('Auth.signIn.createAccount')}
                onClick={() => history.push(routes.SIGNUP)}
                mode="default"
              />
            </FlexContainer>
          </FlexContainer>
        </AuthContainer>
      </GradientBg>
    </>
  );
};

export default SignInView;
